import {
  DefaultButton,
  Dialog,
  DialogFooter,
  DialogType,
  PrimaryButton
} from "office-ui-fabric-react";
import React from "react";
import { connect } from "react-redux";
import { Dispatch } from "redux";
import { RootState } from "../../store/index.store";
import { confirmDialogPropsSelector, uiActions } from "../../store/ui.store";

export interface ConfirmDialogProps {
  title?: string;
  subText?: string;
  isOpen: boolean;
  primaryAction?: () => void;
  secondaryAction?: () => void;
  close: () => void;
}

export const ConfirmDialogComponent = (props: ConfirmDialogProps) => {
  const {
    title,
    subText,
    isOpen,
    primaryAction,
    secondaryAction,
    close
  } = props;

  const secondaryActionCallback = () => {
    if (secondaryAction) {
      secondaryAction();
    } else {
      close();
    }
  };

  return (
    <Dialog
      hidden={!isOpen}
      onDismiss={close}
      dialogContentProps={{
        type: DialogType.normal,
        title,
        subText
      }}
      modalProps={{
        isBlocking: false,
        containerClassName: "dialog",
        styles: { main: { maxWidth: 200 } }
      }}
    >
      <DialogFooter>
        <PrimaryButton onClick={primaryAction} text="OK" />
        <DefaultButton onClick={secondaryActionCallback} text="Cancel" />
      </DialogFooter>
    </Dialog>
  );
};

const mapStateToProps = (state: RootState) => ({
  title: confirmDialogPropsSelector(state).title,
  subText: confirmDialogPropsSelector(state).subText,
  isOpen: confirmDialogPropsSelector(state).isOpen
});

const mapStateToDispatch = (dispatch: Dispatch) => ({
  primaryAction: () =>
    dispatch(uiActions.USER_CLICKED_CONFIRM_PRIMARY_BUTTON()),
  secondaryAction: () =>
    dispatch(uiActions.USER_CLICKED_CONFIRM_SECONDARY_BUTTON()),
  close: () => dispatch(uiActions.SYSTEM_CLOSE_CONFIRM_DIALOG())
});

export const ConfirmDialog = connect(
  mapStateToProps,
  mapStateToDispatch
)(ConfirmDialogComponent);
